//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import gaApi, { GaApi } from 'app/initialization/ga/ga-api';

angular
    .module('curalate.tracking', [])
    .factory('TrackingService', () => gaApi);

export type ITrackingService = GaApi;
